<template>
  <div>
    <v-btn @click="openDialog" icon color="warning" x-small>
      <v-icon small>mdi-pencil</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Edit Sub-Type"
          icon="mdi-pencil"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field
            outlined
            dense
            v-model="form.item_sub_type"
            label="Sub-Type Name"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            v-model="form.description"
            label="Description"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="submit" :loading="loading">Save</v-btn>
          <v-btn @click="dialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">editItemSubTypeModal.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["subType"],
  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        id: "",
        item_type_id: "",
        item_sub_type: "",
        description: "",
      },
    };
  },
  methods: {
    ...mapActions({
      edit_item_sub_type: "item_sub_type/edit_item_sub_type",
    }),
    openDialog() {
      this.form = {
        id: this.subType.id,
        item_type_id: this.subType.item_type_id,
        item_sub_type: this.subType.item_sub_type,
        description: this.subType.description || "",
      };
      this.dialog = true;
    },
    async submit() {
      let x = await this.$confirm({
        title: "Edit Sub-Type",
        message: "Are you sure you want to proceed?",
        color: "primary",
        icon: "mdi-pencil",
      });
      if (x) {
        this.loading = true;
        try {
          await this.edit_item_sub_type(this.form);
          this.$alert({
            title: "Success",
            message: "Successfully edited",
            color: "success",
            icon: "mdi-check-circle",
          });
          this.dialog = false;
          this.$emit("updated");
        } catch (err) {
          this.$alert({
            title: "Error",
            message: "Error: " + err,
            color: "error",
            icon: "mdi-alert-circle",
          });
        }
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
